import React, { ReactNode } from "react";
import styles from "./styles.module.scss";
import classNames from "classnames";

export interface TableColumn<RowData = any> {
  key: string;
  label: string;
  width?: string;
  render?: (value: any, row: RowData) => ReactNode;
}

export interface TableRow {
  id: string | number;
  [key: string]: any;
}

interface TableProps<RowData = TableRow> {
  columns: TableColumn<RowData>[];
  data: RowData[];
  columnVisibility: Record<string, boolean>;
  onRowClick?: (row: RowData) => void;
}

interface TextCellProps {
  value: string | number;
}

export const TextCell = ({ value }: TextCellProps) => {
  return <div className={styles.textCell}>{value || "-"}</div>;
};

const Table = <RowData extends TableRow>({
  columns,
  data,
  columnVisibility,
  onRowClick,
}: TableProps<RowData>) => {
  const visibleColumns = columns.filter((col) => columnVisibility[col.key]);

  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            {visibleColumns.map((col) => (
              <th key={col.key} style={col.width ? { width: col.width } : {}}>
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <tr
              key={row.id}
              onClick={() => onRowClick?.(row)}
              className={classNames({ [styles.clickableRow]: !!onRowClick })}>
              {visibleColumns.map((col) => (
                <td key={col.key}>
                  {col.render ? (
                    col.render(row[col.key], row)
                  ) : (
                    <TextCell value={row[col.key]} />
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
